import React from 'react';
import {
  Grid,
  Box,
  Typography,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import { useOutageLeftPanelState } from '../../providers/OutageLeftPanelStateProvider';
import { useTranslation } from '../../../../hooks/useTranslation';
import FAQIcon from '../../../../static/outageIconsV2/faq.svg';
import colors from '../../../../themes/main-colors';
import { OutageStatusFAQ } from '../outage-status-faq/OutageStatusFAQ';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    expandedContainer: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      padding: theme.spacing(3.75, 2.5),
      backgroundColor: colors.riverBlue,
      borderBottom: `1px solid ${colors.grey2}`,
    },
    expandedHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
    collapsedContainer: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '8px',
      padding: theme.spacing(1.25, 0.5),
      textAlign: 'center',
    },
    title: {
      fontSize: 16,
      fontWeight: 600,
    },
    text: {
      fontSize: 16,
    },
    collapsedText: {
      fontSize: 14,
      fontWeight: 600,
    },
    expandedIcon: {
      width: 25,
      height: 25,
    },
    collapsedIcon: {
      width: 20,
      height: 20,
    },
  }),
);

export const OutageFAQ: React.FC = () => {
  const { panelOpen: expanded } = useOutageLeftPanelState();
  const { t } = useTranslation();
  const classes = useStyles();
  const [openOutageStatusFAQ, setOpenOutageStatusFAQ] = React.useState(false);

  return (
    <>
      {expanded ? (
        <Box
          className={classes.expandedContainer}
          onClick={() => setOpenOutageStatusFAQ(true)}
        >
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <FAQIcon className={classes.expandedIcon} />
            </Grid>
            <Grid item>
              <Typography className={classes.title}>
                {t('OUTAGE_FAQ')}
              </Typography>
            </Grid>
          </Grid>
          <Typography className={classes.text}>
            {t('SOME_COMMON_QUESTIONS')}
          </Typography>
        </Box>
      ) : (
        <Box
          className={classes.collapsedContainer}
          onClick={() => setOpenOutageStatusFAQ(true)}
        >
          <FAQIcon className={classes.collapsedIcon} />
          <Typography className={classes.collapsedText}>{t('FAQ')}</Typography>
        </Box>
      )}
      <OutageStatusFAQ
        open={openOutageStatusFAQ}
        setOpen={setOpenOutageStatusFAQ}
      />
    </>
  );
};
